/**
 * Created by robert.lavoie on 6/16/17.
 */


import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 *
 * @class
 * CustomerSiteColumnCtaComponent
 *
 * @description
 * This component is used when the column type within a section is of type cta
 * The injected content will either be a quill editor or customer-site-column-text
 *
 */
@Component({
  templateUrl: 'customer-site-column-cta.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'customer-site-column-cta',
  styleUrls: ['./customer-site-column-cta.component.scss'],
})
export class CustomerSiteColumnCtaComponent {
  constructor() {}
}
